/**
 * Форматирует деньги в формате: 23 345 32Р
 * Без дробной части
 * @param {*} value
 * @returns
 */
export const formatRublePrice = (value) =>
  new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 0,
  }).format(value);
